import { useEffect, useRef } from 'react';

export const useBoardSelectionSync = ({ value, handlers }) => {
  const previousValueRef = useRef(null);

  useEffect(() => {
    const previousValue = previousValueRef.current;
    Object.entries(handlers || {}).forEach(([key, handler]) => {
      if (typeof handler !== 'function') {
        return;
      }
      if (!previousValue || previousValue[key] !== value[key]) {
        handler(value[key]);
      }
    });
    previousValueRef.current = value;
  }, [handlers, value]);
};
